import {
  SupportCategoryOption,
  SupportTicketDetail,
  SupportTicketListItem,
  SupportTicketListQuery,
  SupportTicketStats,
} from '../models/help-support-tickets';

export interface HelpSupportTicketsState {
  rows: SupportTicketListItem[];
  stats: SupportTicketStats;
  categories: SupportCategoryOption[];
  totalTickets: number;
  selectedTicket: SupportTicketDetail | null;
  loadingList: boolean;
  loadingDetail: boolean;
  loadingCategories: boolean;
  submitting: boolean;
  error: string | null;
  listError: string | null;
  successMessage: string | null;
  currentPage: number;
  pageSize: number;
  listQuery: SupportTicketListQuery | null;
}

export const initialHelpSupportTicketsState: HelpSupportTicketsState = {
  rows: [],
  stats: {
    total: 0,
    open: 0,
    slaCrossed: 0,
    closed: 0,
    reopened: 0,
  },
  categories: [],
  totalTickets: 0,
  selectedTicket: null,
  loadingList: false,
  loadingDetail: false,
  loadingCategories: false,
  submitting: false,
  error: null,
  listError: null,
  successMessage: null,
  currentPage: 1,
  pageSize: 10,
  listQuery: null,
};
